import { z } from "zod";
export const authProviderSchema = z.string().trim().min(1).max(64);
export const redirectTargetSchema = z.string().trim().min(1).max(2_048);
export const tenantCodeSchema = z
    .string()
    .trim()
    .min(1)
    .max(63)
    .regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/, "Tenant code must be a valid hostname label");
export const loginInputSchema = z.object({
    email: z.string().trim().email().max(320),
    password: z.string().min(1).max(1_024),
    mfaToken: z
        .string()
        .regex(/^\d{6}$/, "Enter the six-digit email code")
        .optional(),
    remember: z.boolean().optional(),
    tenantCode: tenantCodeSchema.optional(),
    redirectTo: redirectTargetSchema.optional(),
});
export const registrationInputSchema = z.object({
    email: z.string().trim().email().max(320),
    password: z.string().min(8).max(1_024),
    displayName: z.string().trim().min(1).max(200),
});
export const resetPasswordInputSchema = z.object({
    email: z.string().trim().email().max(320),
});
export const resetPasswordConfirmInputSchema = z.object({
    email: z.string().trim().email().max(320),
    token: z.string().trim().min(1).max(4_096),
    newPassword: z.string().min(8).max(1_024),
});
export const oauthStartInputSchema = z.object({
    provider: authProviderSchema,
    redirectTo: redirectTargetSchema,
});
export const oauthCallbackInputSchema = z.object({
    provider: authProviderSchema,
    code: z.string().min(1).max(4_096),
    state: z.string().min(32).max(4_096),
});
export const googleCredentialInputSchema = z.object({
    credential: z.string().trim().min(1).max(16_384),
});
export const googleCredentialPayloadSchema = z.object({
    sub: z.string().min(1),
    email: z.string().email(),
    name: z.string().min(1),
    given_name: z.string().optional(),
    family_name: z.string().optional(),
    picture: z.string().url().optional(),
});
export const sessionUserSchema = z.object({
    id: z.string().min(1),
    email: z.string().email().optional(),
    displayName: z.string().min(1).optional(),
    tenantCode: z.string().min(1).optional(),
    permissions: z.array(z.string()),
});
export const authFeatureConfigSchema = z.object({
    providers: z.array(authProviderSchema).max(10).default([]),
    defaultRedirect: redirectTargetSchema.default("/app/dashboard"),
    loginPath: z.string().startsWith("/").default("/auth/login"),
    registerPath: z.string().startsWith("/").default("/auth/register"),
    resetPasswordPath: z.string().startsWith("/").optional(),
    minimumPasswordLength: z.number().int().min(8).max(128).default(12),
});
//# sourceMappingURL=contracts.js.map